import { Directive, HostListener, Input } from '@angular/core';
import { Utilities } from '../utilities';

@Directive({
  selector: '[appDigits]'
})
export class DigitsMinMaxDirective {
  @Input('appDigitsMax') maxValue!: number;
  @Input('appDigitsMin') minValue!: number;

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value && (!Utilities.isNullOrUndefined(this.maxValue) || !Utilities.isNullOrUndefined(this.minValue)) && (+value > this.maxValue || +value < this.minValue)) {
      value = value.substring(0, value.length - 1);
    }

    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('input'));
    }
  }
}